
export interface HcLovedOne {
  _id: string;
  csId: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  countryCode: string;
  timezone: string;
  languageId: string; // Reference to HcLanguage
  /** Set true only after Twilio Verify succeeds. Missing or false blocks wellness calls. */
  numberHasBeenValidated?: boolean;
}
